export default __webpack_public_path__ + "static/media/Array.748b3e5a.png";